export default "https://assets.pclncdn.com/web/next-landing/8f5502c/_next/static/images/cobrand-cheap-cruises-promo-c1022ed4b31cfa1f3c44a2ac2331806f.jpg";